import { DgtPdOrderPicklistExtraReturnItem, OrderType } from '../models';
import { ApiResponse, post } from './utils'

import { format } from 'date-fns'

export const postReturnFG = async (
  orderType: OrderType,
  pdOrderNo: string,
  headerText: string,
  returnItems: DgtPdOrderPicklistExtraReturnItem[],
  refDocNo?: string,
): Promise<ApiResponse> => {
  try {
    const path = '/sap/picklist/return';
    const payload = { 
      "orderType": orderType,
      "postingDate": format(new Date(), 'yyyyMMdd'),
      "docDate": format(new Date(), 'yyyyMMdd'),
      "pdOrderNo": pdOrderNo,
      "headerText": headerText,
      "items": returnItems.map(itm => {
        const qty = itm.qty || itm.withShQty || itm.wasteQty || 0
        return {
          "pdOrderNo": itm.orderId,
          "materialCode": itm.materialCode,
          "materialUnit": itm.materialUnit,
          qty,
          "location": itm.returnStorageLocation,
          "text": itm.remark,
          "mvReasonCode": itm.returnReasonCode || ''
        }
      })
    }
    const result = await post(path, refDocNo && refDocNo !== '' ? {
      ...payload,
      "refReturnDoc": refDocNo
    } : payload)
    return {
      success: true,
      docNo: result.docNo,
      docYear: result.docYear
    }
  } catch (error: any) {
    return {
      success: false,
      message: error.response ? error.response.data.message : 'Error from API, Please contact administrator.'
    }
  }
}

export const postReturn = async (
  pdOrderNo: string,
  headerText: string,
  returnItems: DgtPdOrderPicklistExtraReturnItem[]
): Promise<ApiResponse> => {
  try {
    const path = '/sap/picklist/return';
    const result = await post(path, {
      "postingDate": format(new Date(), 'yyyyMMdd'),
      "docDate": format(new Date(), 'yyyyMMdd'),
      "pdOrderNo": pdOrderNo,
      "headerText": headerText,
      "items": returnItems.map(itm => {
        const qty = itm.qty || itm.withShQty || itm.wasteQty || 0
        let location = itm.returnStorageLocation || ''
        if (itm.wasteQty! > 0 && location === '') {
          location = pdOrderNo.startsWith('9') ? 'LREJ':'RMQH'
          // NOTE - Double check for waste location
        }
        return {
          "pdOrderNo": itm.orderId,
          "materialCode": itm.materialCode,
          "materialUnit": itm.materialUnit,
          "batchLotNo": itm.batchLotNo,
          qty,
          location,
          "text": itm.remark,
          "mvReasonCode": itm.returnReasonCode || ''
        }
      })
    })
    return {
      success: true,
      docNo: result.docNo,
      docYear: result.docYear
    }
  } catch (error: any) {
    return {
      success: false,
      message: error.response ? error.response.data.message : 'Error from API, Please contact administrator.'
    }
  }
}